import { Add } from "@mui/icons-material";
import { T } from "../../util/t";
import { Avatar, Button } from "@mui/material";
import { VisualListButton } from "./AthleteSummary";
import { makeStyles } from "../../providers/makeStyles";

const useStyles = makeStyles(theme => ({
    icon: {
        backgroundColor: theme.palette.background.low,
    }
}));
export const AddIcon = () => {
    const classes = useStyles();

    return (
        <Avatar className={classes.icon} aria-hidden={true}>
            <Add/>
        </Avatar>
    );
};

export const AddAthleteButton = ({ numberOfAthletes, onClick, disabled, isSeriesRegistration }) =>
    numberOfAthletes ?
        <Button startIcon={<Add/>} onClick={onClick} disabled={disabled}>
            <T>{isSeriesRegistration ? "Add another athlete" : "New entry"}</T>
        </Button> :
        <VisualListButton
            icon={<AddIcon/>}
            text={<T>{isSeriesRegistration ? "Select athlete" : "New entry"}</T>}
            onClick={onClick}
            disabled={disabled}
        />;
